<template>
  <simple-expansion-card 
    ref="reserveesExpansionCard"
    :value="true"
  >
    <member-preferences 
      v-model="selectedMemberPreferencesId"
      @change="$emit('refresh')"
    />
    <template #title>
      Reservees
    </template>
    <v-row 
      :key="refreshKey"
      no-gutters
    >
      <v-col
        v-for="reservee in getExpandMemberList(reservation, firstReserveeRowSize) || []"
        :key="'reservee-' + reservee.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <reservee-card 
          :reservee="reservee"
          :reservation="reservation"
          @click:avatar="openMemberPreferences(reservee.member)"
        >
          <template #expanded-guests>
            <v-card-text
              v-if="getExpandedGuests(reservee)"
              class="pa-2"
            >
              Guests:
            </v-card-text>
            <v-card-text class="py-0 px-1">
              <v-chip
                v-for="(guest, guestIndex) in getExpandedGuests(reservee)"
                :key="'expanded-guest-' + guestIndex"
                class="ml-0 mr-1 ft-expanded-chip"
              >
                <v-avatar
                  v-if="guest.count > 1"
                  class="grey lighten-1"
                >
                  {{ guest.count }}
                </v-avatar>
                <template v-if="guest.name">
                  <strong>{{ guest.name }}</strong> <span class="ml-2 caption">({{ guest.typeName }})</span>
                </template>
                <span v-else>{{ guest.typeName }}</span>
              </v-chip>
            </v-card-text>
          </template>
        </reservee-card>
      </v-col>
    </v-row>
  </simple-expansion-card>
</template>

<script>
import MemberPreferences from '@/ft-vue-core/components/MemberPreferences'
import ReserveeCard from '@/ft-vue-core/components/ReserveeCard'
import floorPlanHelpers from './mixins/floorPlanHelpers'
import reservationsCommonMethods from '../reservations/mixins/reservationsCommonMethods'
import reserveeCardMethods from '../reservations/mixins/reserveeCardMethods'
export default {
  name: 'SelectedReservationMembers',
  components: {ReserveeCard, MemberPreferences},
  mixins: [floorPlanHelpers, reservationsCommonMethods, reserveeCardMethods],
  props: {
    reservation: {
      type: Object,
      default () {return {}}
    }
  },
  data () {
    return {
      reservees: [],
      guestTypes: [],
      selectedMemberPreferencesId: undefined,
      refreshKey: 'selected-reservation-members',
    }
  },
  computed: {
    firstReserveeRowSize () {
      switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return 1
      case 'sm': 
        return 2
      default: // md and greater
        return 4
      }
    },
    guestTypeMap () {
      return this.guestTypes?.reduce((acc, r) => {
        acc[r.id] = r
        return acc
      }, {}) ?? {}
    }
  },
  mounted () {
    const commands = [
      {
        command: 'member',
        load: this.reservees,
        loading: this.isLoading,
        params: {
          children: true,
          filter: [{field: 'id', operator: 'IN', values: this.reservation?.details?.reduce((acc, r) => {
            if (r.cancelled) {
              return
            }
            acc.push(r.memberId)
            return acc
          }, [])}]
        }
      },
      {
        command: 'guestType',
        load: this.guestTypes,
        loading: this.isLoading,
        params: {filter: [{field: 'activityId', operator: 'EQUAL', values: [9999]}]}
      }
    ]
    this.$ftAPI().get(this.addResourceErrorHandler(commands))
  },
}
</script>